export default __webpack_public_path__ + "static/media/7.3dd106c1.jpg";